// src/utils/sheetsParser.js
export async function getProductsFromPubHtml(csvUrl) {
  try {
    const res = await fetch(csvUrl);
    const text = await res.text();

    // Разбиваем на строки
    const rows = text.trim().split("\n").map(r => r.split(","));
    if (rows.length < 2) return [];

    const headers = rows[0].map(h => h.trim());
    const products = rows.slice(1).map(row => {
      const obj = {};
      row.forEach((cell, i) => {
        obj[headers[i]] = cell.trim();
      });
      return obj;
    });

    console.log("✅ Товары из Google Sheets:", products);
    return products;
  } catch (err) {
    console.error("Ошибка при загрузке Google Sheets:", err);
    return [];
  }
}
